import { Box, Flex, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { ReactElement, RefObject } from "react";
import { formFieldVariants } from "./styles";

export const MotionBox = motion(Box);
export const MotionFlex = motion(Flex);

export const CLOSE_ICON_PATH: string =
  "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";

export const dropdownAnimationProps = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.15 },
} as const;

export const alertAnimationProps = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.2 },
} as const;

export const formFieldProps = (
  order: number,
): { custom: number; initial: string; animate: string; variants: typeof formFieldVariants } => ({
  custom: order,
  initial: "hidden",
  animate: "visible",
  variants: formFieldVariants,
});

export const isClickOutside = (
  event: MouseEvent,
  dropdownRef: RefObject<HTMLDivElement>,
  inputRef: RefObject<HTMLInputElement>,
): boolean =>
  !!dropdownRef.current &&
  !dropdownRef.current.contains(event.target as Node) &&
  !!inputRef.current &&
  !inputRef.current.contains(event.target as Node);

export const scrollToHighlighted = (index: number, ref: RefObject<HTMLDivElement>): void => {
  if (index >= 0 && ref.current) {
    const items: NodeListOf<HTMLLIElement> = ref.current.querySelectorAll("li");
    items[index]?.scrollIntoView({ block: "nearest" });
  }
};

export const BookIcon = (): ReactElement => (
  <Icon viewBox="0 0 24 24" boxSize={6}>
    <defs>
      <linearGradient id="bookGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fff" stopOpacity="1" />
        <stop offset="100%" stopColor="#e2e8f0" stopOpacity="0.8" />
      </linearGradient>
    </defs>
    <path
      fill="url(#bookGradient)"
      d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6zm0 2h5v8l-2.5-1.5L6 12V4z"
    />
    <path
      fill="rgba(255,255,255,0.4)"
      d="M13 4h5v16h-5V4z"
    />
  </Icon>
);

export const CalendarIcon = (): ReactElement => (
  <Icon viewBox="0 0 24 24" boxSize={4} color="gray.500">
    <path
      fill="currentColor"
      d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"
    />
  </Icon>
);

export const EuroIcon = (): ReactElement => (
  <Icon viewBox="0 0 24 24" boxSize={4} color="gray.500">
    <path
      fill="currentColor"
      d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H14v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H14V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.956 8.956 0 0 0 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1s.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
    />
  </Icon>
);
